import EventBus from '__jsEbentBus';
export default {
	data() {
		return {
			fixed:      false,
			top:        0,
			fixedWidth: 0
		};
	},
	methods: {
		initToTop(ref, top, fixedTop) {
			var rect = this.$refs[ref].getBoundingClientRect();
			var bodyRect = document.body.getBoundingClientRect();
			this.top = rect.top - bodyRect.top;
			// this.top = this.$refs[ref].offsetTop + top;
			this.fixedWidth = this.$refs[ref].offsetWidth;
			// this.width = this.$refs[ref].cientWidth;
			EventBus.$on('onscroll', () => {
				this.onScroll();
			});
		},
		onScroll() {
			if (window.pageYOffset > this.top) {
				this.fixed = true;
			}
			else {
				this.fixed = false;
			}
			this.$emit('input', this.fixed);
		}
	},
	beforeDestroy() {
		EventBus.$off('onscroll');
	},
};
